import React from 'react'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import { blog1, disabledperson, elderly, insurancePolicy, maternity, nurse, servcieDetails, shelterCopy, stationery } from '../../Constant'

function ChildCareService() {
  return (
    <>
    <Header />
    <section className="servcies py-10" 
        style={{ backgroundImage: `url(${servcieDetails})` }} 
        >
        <div className="container hero supplement ">
            <div className="row">
                <div className="col-md-6 py-10">
                    <h1 className="white">Child Care</h1>
                    <p className="white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                        incididunt ut labore et dolore magna aliqua. . </p>
                </div>
                <div className="col-md-6"></div>
            </div>
        </div>
    </section>

    <section className="service-details">
        <div className="container">
            <div className="row">
                <div className="col-md-7 " >
                    <div className="container">
                        <div className="row ">
                            <h2 className="grey title-p">Child Care</h2>
                            Finding reliable child care providers has never been easier! Browse through our extensive database of licensed and insured child care providers by rate, hours of operation, even read ratings and reviews from other parents just like you. It couldn't be easier to find the perfect match for your family.
                        </div>
                        <div className="row">
                            <div className="col-md-7" >
                                <img src={blog1} className="py-3"  width="350" alt=""/>
                            </div>
                            <div className="col-md-5 py-5">
                                <ul className="list-unstyled ul-color"  >
                                    <li><i className="fa fa-check"></i> Lorem ipsum dolor sit amet. </li>
                                    <li><i className="fa fa-check"></i> Consectetur adipiscing elit.</li>
                                    <li><i className="fa fa-check"></i> Sed doeiusmod tempor incididunt.</li>
                                    <li><i className="fa fa-check"></i> Ut labore etdolore magna.</li>
                                    <li><i className="fa fa-check"></i> Consectetur adipiscing elit.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="row">
                            <h2 className="grey title-p">Why choose Child care?</h2>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut euismod nisl a neque efficitur egestas. Aliquam tristique est vitae aliquam euismod. Nunc vel odio in lorem accumsan ornare at sed velit. Maecenas vulputate tellus vitae magna vulputate accumsan. Aenean ut rutrum sapien. Curabitur risus risus, porttitor egestas leo ut, maximus ultrices leo. Donec gravida neque id nibh commodo semper. Mauris at quam in nunc tincidunt vulputate. Donec mauris mi, facilisis nec volutpat tincidunt, ornare ut quam. Pellentesque vulputate enim quis arcu posuere volutpat. In gravida blandit mi, non laoreet magna ullamcorper sed. Nulla vitae ligula sed dui dignissim bibendum.

                        </div>

                        <div className="row py-4">

                            <div className="col-md-4 details-box">
                                <img src={insurancePolicy} alt=""/>
                                <h4>Insurance Policy</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut euismod nisl a neque efficitur egestas.</p>
                            </div>
                            <div className="col-md-4 details-box">
                                <img src="img/financial-analysis.png" alt=""/>
                                <h4>Financial Analysis</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut euismod nisl a neque efficitur egestas.</p>
                            </div>
                            <div className="col-md-4 details-box">
                                <img src="img/recovery-scheme.png" alt=""/>
                                <h4>Recovery Scheme</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut euismod nisl a neque efficitur egestas.</p>
                            </div>

                        </div>


                    </div>
                </div>
                <div className="col-md-5 py-10 details-sidebar " >
                    <h2 className="grey bottom-line text-center">Care Services</h2>
                    <div className="row">

                        <div className="details-btn">
                            <span className="img-care"><img src={maternity} alt=""/></span>
                            <span className="txt-care"><a href="./care-giver.php?id=1"> Child Care</a></span>
                        </div>

                        <div className="details-btn">
                            <span className="img-care"><img src={elderly} alt=""/></span>
                            <span className="txt-care"><a href="./care-giver.php?id=2"> Senior Care</a></span>
                        </div>

                        <div className="details-btn">
                            <span className="img-care"><img src={disabledperson} alt=""/></span>
                            <span className="txt-care"><a href="./care-giver.php?id=3"> Special Needs</a></span>
                        </div>

                        <div className="details-btn">
                            <span className="img-care"><img src={shelterCopy} alt=""/></span>
                            <span className="txt-care"><a href="./care-giver.php?id=4"> House Keeping</a></span>
                        </div>

                        <div className="details-btn">
                            <span className="img-care"><img src={nurse} alt=""/></span>
                            <span className="txt-care"><a href="./care-giver.php?id=5"> Nursing Care</a></span>
                        </div>

                        <div className="details-btn">
                            <span className="img-care"><img src={stationery} alt=""/></span>
                            <span className="txt-care"><a href="./care-giver.php?id=6">School Suport</a></span>
                        </div>

                    </div>
                    <div className=" py-10 text-center">
                        {/* <!--                        <img src="img/banner-service.jpg" width="398" alt=""/>--> */}
                        <div className="services-question-card p-5">
                            <div className="question-text">
                                <h4 className="text-light question-heading">Have Question?</h4>
                                <p className="text-light question-text">Our Client care managers are on call 24/7 to answer your questions</p>
                                <a href="support.php" className="contact-us-btn mt-4 text-dark">Contact Us</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Footer />
    </>
  )
}

export default ChildCareService